module.exports = __webpack_public_path__ + "fonts/AvenirNext-Medium.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Avenir_Next/AvenirNext-Medium.ttf
// module id = 3475
// module chunks = 0